export { CardInfoItemPageEntity } from './ui/card-info-item-page';
